module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Healing Power of Pain")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#part-1-the-impact-of-trauma"
    }
  }, [_vm._v("Part 1: The Impact of Trauma")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-tiger-in-carlo"
    }
  }, [_vm._v("1.1. The Tiger in Carlo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#theory-traumaflight-fight-freeze"
    }
  }, [_vm._v("Theory: Trauma—Flight, Fight, Freeze")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#theory-trauma-and-loneliness"
    }
  }, [_vm._v("Theory: Trauma and Loneliness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#theory-processing-reliving-and-reexperiencing-the-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Processing, Reliving and Reexperiencing the Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#exercise-a-different-scenario",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: A Different Scenario")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#lena-i-am-afraid-i-am-getting-too-fat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.2. Lena: I Am Afraid I Am Getting Too Fat")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#theory-attachment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Attachment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#theory-parentification",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Parentification")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#theory-intergenerational-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Intergenerational Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#exercise-finding-the-proper-distance-between-you-and-your-parents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Finding the Proper Distance Between You and Your Parents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#camillas-mirror",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.3. Camilla’s Mirror")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#theory-self-worth-and-shame",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Self-Worth and Shame")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#theory-self-worth-self-care-and-boundaries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Self-Worth, Self-Care and Boundaries")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#theory-the-blind-spot-of-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: The Blind Spot of Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#exercise-i-love-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: I Love You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#elsies-cramp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.4. Elsie’s Cramp")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#theory-chronic-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Chronic Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#theory-dissociation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Dissociation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#theory-resilience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Resilience")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#exercise-a-me-without-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: A Me Without Trauma")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#part-2-trauma-mechanisms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Trauma Mechanisms")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#ramzi-i-have-lost-everything",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1. Ramzi: I Have Lost Everything")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#theory-trauma-energy-and-trauma-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Trauma Energy and Trauma Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#theory-mechanism-1-reacting-on-instinct",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Mechanism 1 Reacting on Instinct")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#theory-trauma-and-human-kindness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Trauma and Human Kindness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#exercise-thinking-of-a-fellow-human-being",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Thinking of a Fellow Human Being")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#anger-and-sadness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anger and Sadness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#isabel-i-want-to-get-rid-of-my-anger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2. Isabel: I Want to Get Rid of My Anger")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#theory-triggers-and-flashbacks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Triggers and Flashbacks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#theory-mechanism-2-being-allergic-to-ones-own-feelings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Mechanism 2 Being Allergic to One’s Own Feelings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#theory-avoidance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Avoidance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#exercise-the-continuous-letter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: The Continuous Letter")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#ruud-big-lies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3. Ruud: Big Lies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#theory-your-worldview-under-pressure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Your Worldview Under Pressure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#theory-mechanism-3-thinking-you-are-going-crazy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Mechanism 3 Thinking You Are Going Crazy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#theory-being-out-of-touch-with-who-you-are",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Being Out of Touch with Who You Are")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#exercise-sitting-on-your-own-chair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Sitting on Your Own Chair")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#anna-the-emptiness-inside-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4. Anna: The Emptiness Inside Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#theory-taboos-reinforce-our-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Taboos Reinforce Our Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#theory-mechanism-4-the-compulsion-to-repeat-the-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Mechanism 4 The Compulsion to Repeat the Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#theory-defusing-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theory: Defusing Trauma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#exercise-i-have-become-who-i-am-because",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: I Have Become Who I Am Because…")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#part-3-healing-our-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Healing Our Trauma")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#and-how-about-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. And How About You?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#exercise-finding-your-own-key-scenarios",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Finding Your Own Key Scenarios")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#exercise-making-a-still-of-your-key-scenario",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Making a Still of Your Key Scenario")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#healing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. Healing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#exercise-a-new-key-scenario",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: A New Key Scenario")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#exercise-letting-go-of-the-traumatic-pain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Letting Go of the Traumatic Pain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#exercise-how-well-have-you-processed-your-trauma",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: How Well Have You Processed Your Trauma?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#you-and-your-boundaries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. You and Your Boundaries")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#exercise-talking-to-your-inner-child",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Talking to Your Inner Child")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#exercise-letting-go-of-roles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Letting Go of Roles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#exercise-your-ideal-self-as-a-guideline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Your Ideal “Self” as a Guideline")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#your-rhythm-your-zest-for-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. Your Rhythm, Your Zest for Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#exercise-walking-meditation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Walking Meditation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#exercise-breathing-in-breathing-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: Breathing In, Breathing Out")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#exercise-from-myself-to-the-other-and-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exercise: From Myself to the Other and Back")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#annex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Annex")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0